<template>
  <div>Funcionalidades</div>
</template>

<script>
export default {}
</script>

<style></style>
